import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";

const STEPS = [
  { key: "received", label: "Received", note: "We have your submission." },
  { key: "reviewing", label: "Under review", note: "A member of the team is reviewing your position." },
  { key: "closed", label: "Closed", note: "This submission has been closed. We will have been in touch by email." },
];

const fmt = (v) => (v ? `${v.slice(0, 10)}` : "");

export default function DealStatus() {
  const { token } = useParams();
  const [data, setData] = useState(undefined);

  useEffect(() => {
    api.get(`/public/deal-status/${token}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [token]);

  const idx = data ? STEPS.findIndex((s) => s.key === data.status) : -1;

  return (
    <div className="min-h-screen landing-bg flex flex-col" data-testid="deal-status-page">
      <header className="border-b border-[#24272B] sticky top-0 z-20" style={{ background: "#0E1012" }}>
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 w-fit" data-testid="deal-status-home-link">
            <span className="solera-symbol" />
            <span className="wordmark text-bone text-sm">Solera Ventures</span>
            <span className="t-cap text-muted-s ml-2 hidden sm:inline fig">solera.vc</span>
          </Link>
          <Link to="/login" className="btn-ghost !py-2 !px-5" data-testid="deal-status-login-link">Login</Link>
        </div>
      </header>

      <main className="flex-1 max-w-2xl w-full mx-auto px-6 py-16">
        {data === undefined && <p className="t-label">Loading</p>}
        {data === null && (
          <div data-testid="deal-status-notfound">
            <span className="t-label">Not found</span>
            <p className="t-small text-muted-s mt-3 measure">
              We could not find a submission for this link. If you believe this is an error, reply to your
              confirmation email and a member of the team will help.
            </p>
          </div>
        )}
        {data && (
          <div>
            <span className="t-label">Your deal submission</span>
            <h1 className="text-bone mt-3" style={{ fontSize: "clamp(26px, 3.4vw, 38px)", lineHeight: 1.15, fontWeight: 400 }} data-testid="deal-status-company">
              {data.company}
            </h1>
            <p className="t-cap text-muted-s mt-2 fig">Submitted {fmt(data.submitted_at)}</p>

            <div className="mt-10 space-y-0" data-testid="deal-status-stepper">
              {STEPS.map((s, i) => {
                const done = i <= idx;
                const current = i === idx;
                return (
                  <div key={s.key} className="hairline py-5 flex gap-5 items-start first:border-t-0 first:pt-0" data-testid={`deal-status-step-${s.key}`}>
                    <span className={`fig t-body ${done ? "text-[#C69A4E]" : "text-muted-s"}`}>{done ? "\u25CF" : "\u25CB"}</span>
                    <div>
                      <span className={`t-body ${done ? "text-bone" : "text-muted-s"}`}>{s.label}{current ? " \u00B7 current" : ""}</span>
                      <p className="t-small text-muted-s mt-1 measure">{s.note}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <p className="t-cap text-muted-s mt-10 measure">
              Solera reads the stock purchase agreement and confirms the transfer with the issuer before any
              price is discussed. This page updates as your submission moves through review, so you can check
              back at any time.
            </p>
          </div>
        )}
      </main>
    </div>
  );
}
